import VueI18n from "vue-i18n";
import Vue from "vue";

Vue.use(VueI18n);

const messages = {
  en: {
    data: {
      measures: "Measures"
    },
    dashboard: {
      proportionFindingTypesHeading: "Finding types",
      poportionMeasureTypesHeading: "Measure types",
      poportionDueDateHeading: "Measures due date",
      averageProcessingTimeHeading: "Average processing time"
    },
    routeDescriptions: {
      dashboard: "Dashboard",
      measures: "Measures",
      averageProcessingTime: "Average processing time",
      findingTypes: "Finding types",
      measureTypes: "Measure types",
      measuresDueDate: "Measures due date"
    },
    $vuetify: {
      dataIterator: {
        rowsPerPageText: "Items per page:",
        rowsPerPageAll: "All",
        pageText: "{0}-{1} of {2}",
        noResultsText: "No matching records found",
        nextPage: "Next page",
        prevPage: "Previous page"
      },
      dataTable: {
        rowsPerPageText: "Rows per page:"
      },
      noDataText: "No data available"
    }
  },
  de: {
    data: {
      measures: "Maßnahmen"
    },
    dashboard: {
      proportionFindingTypesHeading: "Feststellungsarten",
      poportionMeasureTypesHeading: "Maßnahmenarten",
      poportionDueDateHeading:
        "Maßnahmen, die vor/nach Fälligkeitsdatum bearbeitet wurden",
      averageProcessingTimeHeading: "Durchschnittliche Bearbeitungszeit"
    },
    routeDescriptions: {
      dashboard: "Dashboard",
      measures: "Maßnahmen",
      averageProcessingTime: "Durchschnittliche Bearbeitungszeit",
      findingTypes: "Feststellungsarten",
      measureTypes: "Maßnahmenarten",
      measuresDueDate: "Maßnahmen Fälligkeit"
    },
    $vuetify: {
      dataIterator: {
        rowsPerPageText: "Elemente pro Seite:",
        rowsPerPageAll: "Alle",
        pageText: "{0}-{1} von {2}",
        noResultsText: "Keine Elemente gefunden",
        nextPage: "Nächste Seite",
        prevPage: "Vorherige Seite"
      },
      dataTable: {
        rowsPerPageText: "Zeilen pro Seite:"
      },
      noDataText: "Keine Daten vorhanden"
    }
  }
};

const i18n = new VueI18n({
  locale: "en",
  messages: messages,
  silentTranslationWarn: true
});

export const languages = (key: string, ...params: unknown[]) =>
  i18n.t(key, params);

export default i18n;
